import React from "react";

import logo from "../../assets/img/logo.svg";
import { useTranslation } from "react-i18next";

import styles from "./p-register.module.scss";

type Props = {
  showLogo: boolean;
  title: string;
  message?: string;
};

const RegistHeader: React.FC<Props> = ({ showLogo, title, message }) => {
  const { t } = useTranslation();
  return (
    <>
      <div className={styles["p-register__header"]}>
        {showLogo ? (
          <img src={logo} className={styles["p-register__logo"]} />
        ) : null}
        <div className={styles["p-register__ttl"]}>{t(title)}</div>
        {/* <p className={styles["p-register__message"]}>{t(message)}</p> */}
        <p className={styles["p-register__message"]}>
          {message !== undefined
            ? message
                .split("\n")
                .map((message, i) => <span key={i}>{t(message)}</span>)
            : null}
        </p>
      </div>
    </>
  );
};

export default RegistHeader;
